<script lang="ts">
import { ComplaintAirlineInfo, ComplaintDepartmentInfo, ComplaintInfo } from '@/interface/Complaint.interface';
import { ref } from 'vue';

export default {
    props: {
        modelValue: {
            type: Boolean,
            default: false,
        },
        header: {
            type: String,
            default: 't-action-return-to-dpm'
        },
        cancelText: {
            type: String,
            default: 't-back'
        },
        confirmText: {
            type: String,
            default: 't-action-return-to-dpm'
        },
        airlineInfo: {
            type: Object,
            default: {}
        }
    },
    emits: ['update:modelValue', 'onConfirm', 'onCancel'],
    setup() {
        const returnToDpmForm = ref();
        return { returnToDpmForm };
    },
    data() {
        return {
            request: this.airlineInfo as ComplaintAirlineInfo,
            rules: {
                required: (message: any) => {
                    return (v: any) => !!v || message;
                },
            }
        }
    },
    computed: {
        dialogShow: {
            get() {
                return this.modelValue || false
            },
            set(newValue: boolean) {
                this.$emit('update:modelValue', newValue);
            }
        },
    },
    methods: {
        async confirm() {
            const valid = await this.returnToDpmForm.validate();
            if (valid.valid) {
                this.dialogShow = false;
                this.$emit('onConfirm', this.request.returnRemark);
            }
        },
        cancel() {
            this.request.returnRemark = undefined;
            this.dialogShow = false;
            this.$emit('onCancel')
        },
    }
}
</script>

<template>
    <v-dialog v-model="dialogShow" width="80%" :close-on-back="false" persistent>
        <v-form ref="returnToDpmForm" class="admin-form app-form-input" validate-on="submit lazy"
            @submit.prevent="confirm">
            <v-card class="dialog-card">
                <v-toolbar density="compact">
                    <v-toolbar-title>{{ $t(header) }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-toolbar-items>
                        <v-btn icon="mdi-close" @click="dialogShow = false"></v-btn>
                    </v-toolbar-items>
                </v-toolbar>
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                    <div class="text-label">{{ $t('t-action-return-to-dpm-reason') }}</div>
                    <v-text-field v-model.trim="request.returnRemark" class="hide-float-label" variant="outlined"
                        hide-details="auto" density="comfortable" :label="$t('t-please-input')"
                        :rules="[rules.required(`${$t('t-please-fill')}`)]">
                    </v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-container class="mx-0">
                        <div class="d-flex justify-end">
                            <v-btn @click="cancel" variant="outlined" color="primary" size="large">
                                {{ $t(cancelText) }}
                            </v-btn>
                            <v-btn @click="confirm" variant="flat" color="primary" size="large">
                                {{ $t(confirmText) }}
                            </v-btn>
                        </div>
                    </v-container>
                </v-card-actions>
            </v-card>
        </v-form>
    </v-dialog>
</template>